import { LogLevel } from "angular-auth-oidc-client";
import { EnvironmentType } from "./environment-type.enum";

export const environment = {
  type: EnvironmentType.Dev,
  authLogLevel: LogLevel.Debug,
  identityUrl: 'https://login.microsoftonline.com/047afd16-a725-4e2f-9260-fce3985944dc/v2.0',
  redirectUrl:  'https://dev-performpbi.amerihealthcaritas.com/pbi-ui/',
  serviceRootUrl: 'https://dev-performpbi.amerihealthcaritas.com',
  tableauUrl: "https://q1zrx-tab-we.amerihealthcaritas.com/#/views/Superstore/Overview?:iid=2",
  clientId: "ef8dbda3-1736-494c-8c4b-c16cc0b0b9ee",
  filepath: '../../assets/config/config.json'  
};